/* DON'T EDIT THIS FILE: edit original and run build again */ export const argentinaCountryCode = "AR";
export const uruguayCountryCode = "UY";
export const usaCountryCode = "US";
export const argentinaCountryName = "Argentina";
